import Router from './routing/Router';
import useInitizializeApp from '../hooks/useInitizializeApp';
import LoadingScreen from './misc/LoadingScreen';

const App = () => {
	const appInitialized = useInitizializeApp();

	if (appInitialized) {
		return <Router />;
	}

	return <LoadingScreen />;
};

export default App;
